import React, { Component } from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { formatMessage } from '../../../lib/intl';
import { Field } from 'redux-form';

import FormField from '../../form-field';
import '../../../css/trigger-fields.css';

const i18n = defineMessages({
  contributors: {
    id: 'autoPilot.triggerSlots.contributors',
    defaultMessage: '{slotsName}',
  },
  contributors_adult: {
    id: 'autoPilot.triggerSlots.contributors_adult',
    defaultMessage: 'adults',
  },
  contributors_passenger: {
    id: 'autoPilot.triggerSlots.contributors_passenger',
    defaultMessage: 'passengers',
  },
  contributors_ticket: {
    id: 'autoPilot.triggerSlots.contributors_ticket',
    defaultMessage: 'tickets',
  },
  contributors_seat: {
    id: 'autoPilot.triggerSlots.contributors_seat',
    defaultMessage: 'seats',
  },
  contributors_item: {
    id: 'autoPilot.triggerSlots.contributors_item',
    defaultMessage: 'items',
  },
  contributors_shirt: {
    id: 'autoPilot.triggerSlots.contributors_shirt',
    defaultMessage: 'shirts',
  },
  contributors_person: {
    id: 'autoPilot.triggerSlots.contributors_person',
    defaultMessage: 'people',
  },
  contributors_guest: {
    id: 'autoPilot.triggerSlots.contributors_guest',
    defaultMessage: 'guests',
  },
  contributors_player: {
    id: 'autoPilot.triggerSlots.contributors_player',
    defaultMessage: 'players',
  },
  contributors_student: {
    id: 'autoPilot.triggerSlots.contributors_student',
    defaultMessage: 'students',
  },
})

class TriggerFieldsBySlots extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
  }

  render() {
    const { purchase } = this.props;

    return (
      <div className="modal-section">
        <div className="form-inline">
          <p className="h3 inline-part mr-1">
            <FormattedMessage
              id="autoPilot.triggerSlots.makePurchaseWhen"
              defaultMessage="Make purchase when group reaches"
            />
          </p>
          <div className="inline-part number-picker">
            <Field
              name="autoPilotTriggerSlots"
              type="number"
              component={FormField}
              min="1"
              max="999"
              normalize={val => (val === '' ? 0 : parseInt(val, 10))}
              onChange={ev => this.props.onTriggerSlotsChange(ev.target.value)}
            />
          </div>
          <p className="h3 inline-part ml-1">
            {this.formatMessage(i18n.contributors, purchase.slotName)}
          </p>
        </div>
      </div>
    );
  }
}

TriggerFieldsBySlots.defaultProps = {
  minSlots: 1,
  maxSlots: undefined,
  onTriggerSlotsChange: () => { },
  purchase: { slotName: null }
};

export default injectIntl(TriggerFieldsBySlots);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/autopilot/trigger-fields.by-slots.js